<template>
  <div
    v-show="isShowSetPurchase()"
    class="mb-5 text-gray-600">
    <div class="border border-gray-200 bg-white p-6 rounded-lg">
      <div class="w-10 h-10 inline-flex items-center justify-center mb-4">
        <img
          style="width: 40px; height: 40px; opacity: 1"
          :src="logoUrl">
      </div>
      <h2 class="text-lg font-bold title-font">
        <!-- 愛玩動物看護師国家試験対策 全国統一模試まとめ買い -->
        {{ bulkPurchase.title }}
      </h2>
      <p class="leading-relaxed text-base mb-2">
        (まとめ割:{{ formatPrice(bulkPurchase.price) }}円)
      </p>
      <p class="leading-relaxed text-base">
        以下の模試をまとめて購入します。
      </p>
      <div
        v-for="exam in bulkPurchase.examinations"
        :key="exam.id">
        <p class="leading-relaxed text-base font-bold">
          ・{{ exam.title }}
        </p>
      </div>
      <p class="leading-relaxed text-base">
        (購入する模試をお選びいただくことはできません)
      </p>
      <p class="leading-relaxed text-base">
        単体で模試を購入するよりお得です。
      </p>

      <button
        v-if="isBulkPurchaseUnavailable()"
        class="mt-2 px-8 py-2 rounded bg-gray-600 text-blue-50 max-w-max shadow-sm opacity-50 cursor-not-allowed"
        disabled>
        購入不可
      </button>
      <button
        v-else-if="isOutOfTermSet()"
        class="mt-2 px-8 py-2 rounded bg-gray-600 text-blue-50 max-w-max shadow-sm hover:opacity-50 opacity-50 cursor-not-allowed">
        購入期間外
      </button>
      <button
        v-else
        class="mt-2 px-8 py-2 rounded bg-blue-600 text-blue-50 max-w-max shadow-sm hover:opacity-75 disabled:opacity-50 disabled:cursor-not-allowed"
        @click="handlePurchaseTicket">
        購入する
      </button>
      <p
        v-if="isBulkPurchaseUnavailable()"
        class="text-red-400 leading-relaxed text-base mt-2">
        {{ bulkPurchaseUnavailableMessage }}
      </p>
      <p
        v-if="!isBulkPurchaseUnavailable() && isOutOfTermForTicket()"
        class="text-red-400 leading-relaxed text-base">
        ※{{ formatDate(getSetReceptionStart()) }}よりご購入いただけます。
      </p>
    </div>
  </div>
</template>

<script setup>
import moment from 'moment'
import formatDate from '@/actions/format/date'
import formatPrice from '@/actions/format/formatPrice'

const props = defineProps({
  selectedExamId: {
    type: Number,
    required: true,
  },
  selectedExamination: {
    type: Object,
    required: true,
  },
  examinations: {
    type: Array,
    required: true,
  },
  purchases: {
    type: Array,
    required: true,
  },
  bulkPurchase: {
    type: Object,
    default: null,
  },
})

// まとめ売り表示ブロックのロゴURL
const logoUrl = '/images/Exam/Ticket-icon.svg'
const bulkPurchaseUnavailableMessage = '購入できない状態です。管理者に問い合わせてください。'

const emit = defineEmits(['purchase-ticket'])

const isPurchased = (id) => props.purchases.filter((purchase) => purchase.exam_id === id).length

const isBulkPurchaseUnavailable = () => !props.bulkPurchase?.bundle_price_id
  || !props.bulkPurchase?.examinations?.length

const handlePurchaseTicket = () => {
  if (!isBulkPurchaseUnavailable()) {
    emit('purchase-ticket', props.bulkPurchase)
  }
}

const isShowSetPurchase = () => {
  // まとめ買い情報がない場合は表示しない
  if (!props.bulkPurchase) {
    return false
  }

  // まとめ買いに含まれる模試のいずれかが購入済みの場合は表示しない
  const bulkExamIds = props.bulkPurchase.examinations?.map(exam => exam.id) || []
  const hasAnyPurchased = bulkExamIds.some(examId => isPurchased(examId))

  if (hasAnyPurchased) {
    return false
  }

  return true
}

// まとめ買いの受付期間（含まれる模試の最も早い開始〜最も遅い終了）で判定
const getSetReceptionRange = () => {
  const exams = props.bulkPurchase?.examinations || []
  if (!exams.length) return { start: null, end: null }

  const starts = exams
    .map(e => (e?.reception_start ? moment(e.reception_start) : null))
    .filter(m => m && m.isValid())
  const ends = exams
    .map(e => (e?.reception_end ? moment(e.reception_end) : null))
    .filter(m => m && m.isValid())

  if (!starts.length || !ends.length) return { start: null, end: null }

  // moment.min/max は配列形式で受け取る
  const start = moment.min(starts)
  const end = moment.max(ends)
  return { start, end }
}

const getSetReceptionStart = () => getSetReceptionRange().start

const isOutOfTermSet = () => {
  const { start, end } = getSetReceptionRange()
  if (!start || !end) return true
  const now = moment()
  return now.isBefore(start) || now.isAfter(end)
}

const isOutOfTermForTicket = () => {
  const start = getSetReceptionStart()
  if (!start) return true
  const now = moment()
  return now.isBefore(start)
}
</script>
